var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tips',{attrs:{"data":_vm.tipsList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }